import Table from '@components/Table'
import useCompanyColumnDefs from '@hooks/useCompanyColumnDefs'
import type { Company } from '@models/company'
import {
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'

interface CompaniesTableProps {
  data: Company[]
  onClickEdit: (companyId: number) => void
  onClickRow: (companyId: number) => void
  onClickDelete?: (companyId: number) => void
  canDelete?: boolean
}

const CompaniesTable = ({
  data,
  onClickEdit,
  onClickRow,
  onClickDelete,
  canDelete,
}: CompaniesTableProps) => {
  const columnDefs = useCompanyColumnDefs({
    onClickEdit,
    onClickDelete,
    canDelete,
  })

  const table = useReactTable({
    columns: columnDefs,
    data,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    columnResizeMode: 'onChange',
  })

  return <Table table={table} onClickRow={row => onClickRow(row.id)} />
}

export default CompaniesTable
